import { getLifecycle } from 'service/utils';

const REDUCER_NAME = 'SPORTSCOUNTRIES';
export const SPORTS_COUNTRIES_ACTION = getLifecycle(REDUCER_NAME, 'SPORTS_COUNTRIES_ACTION');
